<script setup lang="ts">
import LoginForm from "@/components/auth/LoginForm.vue";
import LogoSVG from "@/components/LogoSVG.vue";
import { useAuthStore, useSnackbarStore } from "@/stores";
import { useAppStore } from "@/stores/app";
import { HTTPResponseError } from "@soft-db/http";
import { useRouteQuery } from "@vueuse/router";
import { ref } from "vue";
import { useRouter } from "vue-router";

const authStore = useAuthStore();
const appStore = useAppStore();

const loading = ref(false);

const router = useRouter();

const redirectTo = useRouteQuery<string>("redirect");

const { t } = useI18n();

const snackbarStore = useSnackbarStore();
async function emailPasswordLogin({ username, password }: { username: string; password: string }) {
	loading.value = true;

	try {
		await authStore.login(username, password);

		appStore.init();
		router.push(redirectTo.value ? redirectTo.value : { name: "map" });
	} catch (e) {
		let message = "";
		if (e instanceof HTTPResponseError && e.status < 500) {
			message = t("snackbar.invalidUsernameOrPassword");
		} else {
			message = t("snackbar.internalServerError");
		}

		snackbarStore.openOnError(message);
	} finally {
		loading.value = false;
	}
}
</script>

<template>
	<div class="flex h-full w-full flex-col">
		<div class="grow text-center">
			<div class="mx-auto size-20 rounded-full bg-white p-4">
				<LogoSVG class="fill-black!" />
			</div>
			<!-- </AppAvatar> -->
			<h1 class="mt-2 text-center">{{ $t("common.appname") }}</h1>
		</div>
		<div>
			<LoginForm class="pt-6" :loading="loading" @login="emailPasswordLogin" />
		</div>
		<div class="grow"></div>
	</div>
</template>
